module.exports = __webpack_public_path__ + "img/video.2338fbf1.png";